/**
 * Re-initializes Reviews.io rating snippets after the product grid is updated
 * (e.g. collection filters, sort, search results). The widget only runs on load,
 * so new .ruk_rating_snippet elements must be initialized after AJAX grid updates.
 */
import { ThemeBus } from './events-bus.js';
import { EVENTS } from './event-constants.js';

function reinitReviewsIoSnippets() {
  if (typeof window.initReviewsIoSnippets === 'function') {
    requestAnimationFrame(() => {
      window.initReviewsIoSnippets();
    });
  }
}

ThemeBus.addEventListener(EVENTS.filtersApplied, (e) => {
  if (e.detail && e.detail.status === 'done') {
    reinitReviewsIoSnippets();
  }
});

ThemeBus.addEventListener(EVENTS.gridUpdated, reinitReviewsIoSnippets);
